// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3tuYY","productName":"Table_productName__PaR_Z"};